import * as Yup from 'yup';
import { Locale } from '@synergy/models';
import { fields } from '@synergy/utils';

import { UnitFormikValues } from '../models/unit-formik-values';

const fieldNames = fields<UnitFormikValues>();

export const unitsModalValidationSchema = (locale: Locale) =>
    Yup.object().shape({
        [fieldNames.translations]: Yup.object().shape({
            [locale]: Yup.string().required('app.error.required'),
        }),
    });
